import React, { useEffect, useState } from 'react';
import { Tabs, Tab, Box, Typography, IconButton, Paper, InputBase } from '@mui/material';
import { Search, Upload, Add, FilterList, UploadOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllSubcategoryThunk, setSubcategoryRefresh } from '../../../redux/subcategories/getAllSubcategorySlice';
import { toast } from 'react-toastify';
import api from '../../../utils/api';
import UserHeader from '../../../component/reusable/UserHeader';
import { styled } from '@mui/material/styles';
import AllVendor from '../../../component/allvendor/AllVendor';
import { exportVendorThunk, getAllVendorThunk, setVendorPage } from '../../../redux/vendor/vendorSlice';
import AllCustomers from '../../../component/allCustomers/AllCustomers';
import TabHead from '../../../component/reusable/Tab';
import { exportCustomerThunk } from '../../../redux/customer/customerSlice';
import { exportDataExcel, fomateDate } from '../../../utils/fomateDate';

const SearchInput = styled(Paper)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    boxShadow: 'none',
    border: `1px solid ${theme.palette.divider}`,
    width: '320px',
    margin: "20px 0px",
    fontFamily: `'Public Sans', sans-serif`,
}));

function Vendor() {
    const { vendor, loading, error, refresh ,exportLoading,page} = useSelector((state) => state.vendor);

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [search, setSearch] = useState('')
    // const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [selectedTab, setSelectedTab] = useState(0);
    const [sortBy, setSortyBy] = useState('createdAt');
    const [order, setOrder] = useState('asc')
    const status = selectedTab === 0 ? "APPROVED" : selectedTab === 1 ? "PENDING" : "REJECTED"


    const vendors = vendor?.data
    const totalPages = vendor?.totalPages
    const totalItems = vendor?.totalItems
    const itemsPerPage = vendor?.limit


    // calculate start & end of items -------------------
    const start = (page - 1) * limit + 1;
    const end =
        totalPages === page
            ? totalItems
            : (page - 1) * limit + limit;



    useEffect(() => {
        dispatch(getAllVendorThunk(`?search=${search}&page=${page}&status=${status}&limit=${limit}&sortBy=${sortBy}&order=${order}`));
    }, [page, search, limit, refresh, selectedTab,sortBy,order]);



    const handleChange = (event, newValue) => {
        dispatch(setVendorPage(1))
        setSearch("")
        setSelectedTab(newValue);
    };

   
    const exportData = async () => {
        const statusss = `?status=${status}`
        const data = await dispatch(exportVendorThunk(statusss))
        
        if (data?.payload?.success === true) {
            const vendorData = data?.payload?.data
            const exportdata = vendorData?.map((item) => ({
                'name': item?.fullName || '-',
                'phone': item?.phone || '-',
                'email': item?.email || '',
                'gstn': item?.gstn || '',
                'status': item?.status || '-',
                'activeStatus': item?.activeStatus || '-',
                'admin': item?.admin?.name || '-',
                'createdAt': fomateDate(item?.createdAt) || '-',
            }))
            exportDataExcel(exportdata, "vendor")
        }
    }


    const handleOpenMenu = (sort) => {
        setSortyBy(sort)
        setOrder((prevOrder) => (prevOrder === 'asc' ? 'desc' : 'asc'));
    };
    
    return (
        <>
            <UserHeader
                index="Vendors"
                root="Dashboard"
                onClickadd={() => navigate('/users/addVendor')}
                buttonText={'Add Vendor'}
                exportData={exportData}
                exportLoading={exportLoading}
            />
            <Box>
            <TabHead handleChange={handleChange} selectedTab={selectedTab} label={'All Vendors'}/>

                <Box mt={2}>
                    <SearchInput onChange={(e) => setSearch(e.target.value)}>
                        <IconButton aria-label="search">
                            <Search />
                        </IconButton>
                        <InputBase placeholder="Search…" />
                    </SearchInput>
                    {loading ?
                        <div>please wait...</div>
                        :
                        <>
                            {vendors?.length > 0 ?
                                <>

                                    <Typography>
                                        <AllVendor
                                            vendors={vendors}
                                            setPage={setVendorPage}
                                            page={page}
                                            itemsPerPage={itemsPerPage}
                                            totalItems={totalItems}
                                            start={start}
                                            end={end}
                                            selectedTab={selectedTab}
                                            handleOpenMenu={handleOpenMenu}
                                        />
                                    </Typography>

                                </>
                                :
                                <div>
                                    no vendors found
                                </div>
                            }
                        </>
                    }
                </Box>
            </Box>
        </>
    );
}

export default Vendor;
